import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductCategoriesState } from './product-categories.state';

export const selectProductCategoriesState = createFeatureSelector<ProductCategoriesState>('adminProductCategories');

export const selectAllProductCategories = createSelector(
  selectProductCategoriesState,
  (state) => state.categories,
);

export const selectProductCategoriesLoading = createSelector(
  selectProductCategoriesState,
  (state) => state.loading,
);

export const selectProductCategoriesPagination = createSelector(
  selectProductCategoriesState,
  (state) => ({
    total: state.total,
    page: state.page,
    limit: state.limit,
    totalPages: state.totalPages,
  }),
);

export const selectProductCategoriesParams = createSelector(
  selectProductCategoriesState,
  (state) => state.params,
);

export const selectProductCategoriesError = createSelector(
  selectProductCategoriesState,
  (state) => state.error,
);
